import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { CapGainsEstimatesListing } from '@products/types/tax.type';
import { FundShareClassId } from '@types';
import { UsCapitalGainsEstimatesListingComponent } from '../../us-capital-gains-estimates-listing.component';

type FundSelectCellRendererComponentParams = ICellRendererParams & {
  parentComponent: UsCapitalGainsEstimatesListingComponent;
};

@Component({
  selector: 'ft-fund-select-cell-renderer',
  templateUrl: './fund-select-cell-renderer.component.html',
  styleUrls: ['./fund-select-cell-renderer.component.scss'],
})
export class FundSelectCellRendererComponent {
  isCheckboxSelected = false;
  paramsContext: ICellRendererParams;
  parentComponent: UsCapitalGainsEstimatesListingComponent;

  agInit(params: FundSelectCellRendererComponentParams) {
    this.paramsContext = params;
    this.parentComponent = params.parentComponent;

    // Mark the checkbox 'checked', if 'isSelected' is 'true' in cell data.
    this.isCheckboxSelected = (this.paramsContext
      .data as CapGainsEstimatesListing).isSelected;
  }

  /**
   * Handle fund selection/deselection.
   * Make whole row selected when checkox is checked.
   * And, update the parent component 'onRowSelected' method.
   */
  onCheckboxClicked(): void {
    this.isCheckboxSelected = !this.isCheckboxSelected;
    this.paramsContext.node.setSelected(this.isCheckboxSelected);

    const selectedRow: CapGainsEstimatesListing = this.paramsContext.node.data;

    this.parentComponent.onRowSelected({
      selectedFundShareClassId: `${selectedRow.fundId}-${selectedRow.shareClassCode}` as FundShareClassId,
      isSelected: this.isCheckboxSelected,
    });
  }
}
